import useStore from "../../hooks/useStore";
import {
  getValType,
  cn,
  highlgihtInfoObj,
  clearDataState,
  isID,
} from "../../utils";
import { T } from "../../global";
import InfoTag from "./InfoTag";

export default function DatabaseRenderer() {
  const data = useStore((state) => state.data);
  const pivotObject = useStore((state) => state.pivotObject);

  function syncHighlighting(schema, attr, attrType) {
    if (attrType === T.LIST || attrType === T.DB) {
      const _attrs = schema[attr];
      _attrs.forEach((_attr) => {
        try {
          const cn = `${_attr}-sframe`;
          highlgihtInfoObj(cn);
        } catch (e) {
          // console.log(e);
        }
      });
    } else if (attrType === T.VAL && !isID(attr)) {
      const _attr = schema[attr];
      try {
        const cn = `${_attr}-sframe`;
        highlgihtInfoObj(cn);
      } catch (e) {
        // console.log(e);
      }
    }
  }

  function clearHighlighting(schema, attr, attrType) {
    if (attrType === T.LIST || attrType === T.DB) {
      const _attrs = schema[attr];
      _attrs.forEach((_attr) => {
        try {
          const cn = `${_attr}-sframe`;
          clearDataState(cn);
        } catch (e) {
          // console.log(e);
        }
      });
    } else if (attrType === T.VAL && !isID(attr)) {
      const _attr = schema[attr];
      try {
        const cn = `${_attr}-sframe`;
        clearDataState(cn);
      } catch (e) {
        // console.log(e);
      }
    }
  }
  function recursiveRender(parent, name, data) {
    const schemaType = getValType(data);
    // console.log(schemaType, data);
    switch (schemaType) {
      case T.OBJ:
        if (parent === null) {
          // name of the database
          const taskStructure = pivotObject === name;

          return (
            <div
              key={`${name}-${data.id}`}
              className={cn(
                "structure-frame",
                taskStructure
                  ? "task-structure-frame"
                  : "entity-structure-frame entity-data-frame",
                `${name}-sframe ${data.id}-sframe`
              )}
            >
              {taskStructure && <InfoTag name={name} />}
              {!taskStructure && <InfoTag name={data.id} mode="id" />}
              {Object.keys(data).map((attr) => {
                const attrType = getValType(data[attr]);
                return (
                  <div
                    key={attr}
                    className={cn(
                      "info-obj-chip",
                      `info-obj-${attrType}`,
                      "info-obj-data"
                    )}
                  >
                    <span
                      className="data-attr"
                      onMouseEnter={() =>
                        syncHighlighting(data, attr, attrType)
                      }
                      onMouseLeave={() =>
                        clearHighlighting(data, attr, attrType)
                      }
                    >
                      {attrType === T.LIST || attrType === T.DB ? attr : attr}
                    </span>
                    <span className="data-val">
                      {JSON.stringify(data[attr])}
                    </span>
                    {recursiveRender(name, attr, data[attr])}
                  </div>
                );
              })}
            </div>
          );
        } else {
          return;
        }
      case T.DB:
        // console.log(name);
        if (parent === null) {
          // name of the database
          const taskStructure = pivotObject === name;
          return (
            <div
              key={`${name}-${data.id}`}
              className={cn(
                "structure-frame",
                "entity-database-frame",
                taskStructure
                  ? "task-structure-frame"
                  : "entity-structure-frame",
                `${name}-sframe`
              )}
            >
              <InfoTag name={name} />
              {data.map((d) => {
                return recursiveRender(null, name, d);
              })}
            </div>
          );
        }

        return null;

      default:
        return null;
    }
  }
  return (
    <div className="main-container">
      {Object.keys(data).map((k) => {
        // render every database
        return recursiveRender(null, k, data[k]);
      })}
    </div>
  );
}
